
import '@aksharma25/react-schedulers-theralytics/lib/css/react-big-calendar.css';
import {
  getOfficeHours,
  getPatientAppointmentList,
} from '../actions';
import React, { Component } from 'react';
import BigCalendar from '@aksharma25/react-schedulers-theralytics';
import { connect } from 'react-redux';
import history from '../../../../../history';
import moment from 'moment';
import DatePicker from 'material-ui/DatePicker';
import RaisedButton from 'material-ui/RaisedButton';
import CancelAppointmentDialog from '../../../../scheduling/cancelAppointmentDialog';
import Alert from 'react-s-alert';
import {BEHAVIOR_BLOSSOMS, EBS, NE_ABA, BESTABA, DEMO, CBG, AIP, BUILDABLOCKTHERAPY, SWANCONSULTINGINC, CAS, VICTORIOUSLEARNING, ABAORLANDO, POSITIVEBEHAVIORSTEPS, SOAR, HYPERIONCENTER, HELPINGHANDS, FUTURES, TFABA, IAT } from '../../../../../actions/utilAction';
import { getAppConfigList } from '../../../../AppConfig/actions';

BigCalendar.setLocalizer(
  BigCalendar.momentLocalizer(moment)
);

class Scheduling extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appointments: [],
      patient_id: props.patientId,
      patient_views: ['month', 'week', 'day'],
      currentLocation: props.currentLocation,
      currentLocationId: props.currentLocationId,
      startHour: '00',
      startMinutes: '00',
      endHour: '24',
      endMinutes: '00',
      appointmentId: null,
      showCancelAppointmentDialog: false,
      lock_scheduler: null,
    };

    let width = window.innerWidth
                || document.documentElement.clientWidth
                || document.body.clientWidth;

    // let height = window.innerHeight
    //             || document.documentElement.clientHeight
    //             || document.body.clientHeight;
    let view = (width < 768) ? 'day' : 'month';
    this.filter = {
      currentView: view,
      currentMonth: moment().get('month'),
      DateObject: {
        fromDate: null,
        toDate: null,
      },
    };
    this.openDialog = this.openDialog.bind(this);
    this.onNavigateMonth = this.onNavigateMonth.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.handleStaffView = this.handleStaffView.bind(this);
    this.closeCancelAppointmentDialog = this.closeCancelAppointmentDialog.bind(this);
  }

  /*
    function: filter the first and last date of the month from given datetime.
    params: currentDate- date of the any month.
    desc: sets the class filter.DateObject {fromDate: 1/1/2017, toDate: 2/1/2017}
  */
  setFilteredDateObject(currentDate) {
    if (!currentDate) {
      currentDate = new Date();
    }
    // get first and last days of the month
    let firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    let lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    // calculate week start and end date of the month ...
    let weekStartDate = moment(firstDay).startOf('week').isoWeekday(0);
    let weekEndDate = moment(lastDay).endOf('week').isoWeekday(-1);
    for (var i = 0; i < 7; i++) {
      weekStartDate.format('ddd D-M-Y');
      weekStartDate.add('d', 1);
      weekEndDate.format('ddd D-M-Y');
      weekEndDate.add('d', 1);
    }
    let fromDate = moment(weekStartDate).format('YYYY-MM-DD');
    let toDate = moment(weekEndDate).format('YYYY-MM-DD');

    this.filter.DateObject = {
      fromDate: fromDate,
      toDate: toDate,
    };
  }

  componentWillMount() {
    this.props.getAppConfigList();
    this.setFilteredDateObject();

    // this.props.getMasterData();
    this.props.getOfficeHours(this.state.currentLocationId);
    this.get_patient_appointments();
  }

  /*
    function: get the filtered appointmets for a particular Client.
    filters: {fromDate, toDate, patientIds, locationIds}
    desc: calls the api for get Client appointments from the Client id, location id and filter.DateObject {fromDate: 1/1/2017, toDate: 2/1/2017}
  */
  get_patient_appointments() {
    let patientId = this.state.patient_id;
    let searchObj = {
      filters: {
        'fromDate': this.filter.DateObject.fromDate,
        'toDate': this.filter.DateObject.toDate,
        'patientIds': patientId,
        // 'locationIds': this.state.currentLocationId,        
      },
    };

    if (Object.keys(searchObj.filters).length) {
      this.props.getPatientAppointmentList(searchObj);
    }

  }
  formattedAppointments(appointments) {
    // console.log(appointments);
    // let noImagePath = 'https://api.theralytics.net/templates/img/NoImageAvailable.png';
    let noImagePath = '';
    let formatted_apoointments = [];    
    if (this.props.agencyName.toUpperCase() === BEHAVIOR_BLOSSOMS)
    {
      appointments = appointments.data.filter((obj) => obj.cancelTypeId === 0 && obj.isDirectService === true);
    }
    else
    {
      appointments = appointments.data;
    }
    appointments.forEach((appointment, index) => {

      // if (appointment.isTelehealthAppointment) {
      let staffNames = [];
      staffNames = appointment.appointmentStaffs.map((staff) => {
        return staff.staffName;
      });
      let startDateTime = appointment.startDateTime;
      let endDateTime = appointment.endDateTime;
      let startTime = moment(startDateTime).format('h:mm A');
      let endTime = moment(endDateTime).format('h:mm A');
      let patientName = appointment.patientName ? appointment.patientName : '';
      let staffName = staffNames && staffNames.length ? staffNames.join(',') : 'No Staff';
      let patientPhoto = appointment.patientPhotoThumbnailPath ? appointment.patientPhotoThumbnailPath : noImagePath;
      let appointmentTypeName = appointment.appointmentTypeName;
      let allowMultipleStaff = false;
      let soapNoteTitle = '';
      let setProfileTitle = 'View Profile';
      let isCancelAction = appointment.cancelTypeId ? false : true;
      let isAppoinmentCancelled = appointment.cancelTypeId ? true : false;
      let isAppointmentRendered = appointment.claimId ? true : false;
      let cancellationReason = appointment.cancelTypeId ?  appointment.cancelTypeName + ' - Cancellation Reason : ' + appointment.cancelReason : '-' ;
      if (appointment.isTelehealthAppointment) {
        soapNoteTitle = 'Join video call';
      }
      if (appointment.patientEncounterId && ((appointment.claimId && appointment.claimId > 0) || this.state.lock_scheduler === null || !this.checkIsSameOrBefore(moment(startDateTime).format('YYYY/MM/DD'), moment(this.state.lock_scheduler).format('YYYY/MM/DD')))) {
        soapNoteTitle = appointment.isBillable ? 'View Session Note' : 'View Non-Billable Note';
        isCancelAction = false;
      }


      formatted_apoointments.push({
        title: staffName,
        // startDateTime: startDateTime,
        // endDateTime: endDateTime,
        start: new Date(startDateTime),
        end: new Date(endDateTime),
        note: appointment.notes,
        id: appointment.patientAppointmentId,
        resourceId: appointment.staffID,
        patient_id: appointment.patientID,
        name: patientName,
        appointment_type_id: appointment.appointmentTypeID,
        StaffIDs: appointment.StaffIDs,
        location_type_id: appointment.PatientLocationID,
        patientName: '',
        clinicianImage: this.state.patient_id ? noImagePath : patientPhoto,
        clinicianName: this.state.patient_id ? staffName : patientName,
        appointmentType: appointmentTypeName,        
        appointmentBackgroundColor: appointment.color,
        appointmentFontColor: appointment.fontColor,
        appointmentTime: `${startTime} - ${endTime}`,
        appointmentAddress: appointment.address || '-',
        coPay: '0.00',
        RecurrenceRule: appointment.recurrenceRule,
        RecurrencePattern: appointment.recurrencePattern,
        ServiceID: appointment.serviceID,
        ServiceAddressID: appointment.serviceAddressID,
        ServiceLocationID: appointment.serviceLocationID,
        appointmentId: 0,
        parentAppointmentId: appointment.parentAppointmentId,
        isRecurrence: appointment.isRecurrence,
        isAppointmentRendered: isAppointmentRendered,
        isAppoinmentCancelled: isAppoinmentCancelled,
        cancellationReason: cancellationReason,
        soapNoteTitle: soapNoteTitle,
        patientEncounterId: appointment.patientEncounterId ? appointment.patientEncounterId : 0,
        allowMultipleStaff: allowMultipleStaff,
        isBillable: appointment.isBillable,
        setProfileTitle: setProfileTitle,
        isRecurrenceEdit: false,
        isEdit: false,
        isDelete: false,
        // isCancel: isCancelAction,
        isVideoCall: appointment.isTelehealthAppointment,
        noteTypeId: appointment.noteTypeId,
      });
      // }
    });

    if (this.filter.currentView === 'month') {
      formatted_apoointments = formatted_apoointments.map((Obj) => {
        Obj.title = Obj.appointmentTime + '\n' + Obj.title;
        return Obj;
      });
    }
    this.setState({ appointments: formatted_apoointments });
  }

  checkIsSameOrBefore = (date1, date2) => {
    return moment(date1).isSameOrBefore(date2);  
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.appointments && nextProps.appointments !== this.props.appointments) {
      if (nextProps.appointments.data && nextProps.appointments.data.length) {
        this.formattedAppointments(nextProps.appointments);
      }
    }

    if (nextProps.cancelledAppointment && this.props.cancelledAppointment !== nextProps.cancelledAppointment) {
      this.get_patient_appointments();
    }

    if (nextProps.officeHours && this.props.officeHours !== nextProps.officeHours) {
      // this.setState({ officeTime: nextProps.officeHours });
      if (nextProps.officeHours.data) {
        // let startTime = nextProps.officeHours.data.startTime || '00:00:00',
        //   endTime = nextProps.officeHours.data.endTime || '23:59:00',
        //   startHour = startTime.substring(0, 2),
        //   startMinutes = startTime.substring(3, 5),
        //   endHour = endTime.substring(0, 2),
        //   endMinutes = endTime.substring(3, 5);


      let startTime = moment(nextProps.officeHours.data.startTime).format('HH:mm:ss') || '06:00:00',
        endTime = moment(nextProps.officeHours.data.endTime).format('HH:mm:ss') || '23:00:00',
        startHour = startTime.substring(0, 2),
        startMinutes = startTime.substring(3, 5),
        endHour = endTime.substring(0, 2),
        endMinutes = endTime.substring(3, 5);

        this.setState({ startHour: startHour, startMinutes: startMinutes, endHour: endHour, endMinutes: endMinutes });
      }
    }

    if (nextProps.app_config && this.props.app_config !== nextProps.app_config) {
      let app_config = nextProps.app_config;
      let lock_scheduler = null;     
      if (app_config && app_config.length) {
        app_config.forEach((Obj) => {
          if (Obj.configType === 3) {
            switch (Obj.key) {
            case 'LOCK_SCHEDULER':
              lock_scheduler = Obj.value ? Obj.value.toString() : null;
              break;            
            default:
              break;
            }
          }
        });     
        this.setState({ lock_scheduler });
      }     
    }
  }

  openDialog = (slotInfo) => {

     let patientMySoap = `my-soap`; 
     let patientCustomSessionSoapNote = `client-customsession-soap`; 



    // console.log(slotInfo);
    if (slotInfo.action === 'view_profile') {
      // history.push(`/my-profile/${slotInfo.patient_id}`);
    } else if (slotInfo.action === 'soap_note' && slotInfo.soapNoteTitle) {
      // JWM TODO: This should be done by MasterNoteType.Key instead
      // if (slotInfo.noteTypeId <= 201) {
      //   let path = `custom-session-notes/${slotInfo.id}/${slotInfo.patientEncounterId}`; 
      //   history.push(path);
      // } else 
      // history.push('/video-call/' + slotInfo.id);
      if (!slotInfo.isBillable) {
          let path = `/my-nonBillable-soap/${slotInfo.id}/${slotInfo.patientEncounterId}`;          
          history.push(path);
      } else if (slotInfo.isVideoCall) {
        history.push('/video-call/' + slotInfo.id);
      } else {
        if(this.props.agencyName.toUpperCase() === BEHAVIOR_BLOSSOMS)
        { 
          if(slotInfo.noteTypeId === 101){          
            history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else {
            history.push(`/my-session-behaviorblossoms/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
        }
        else if(this.props.agencyName.toUpperCase() === DEMO || this.props.agencyName.toUpperCase() === BUILDABLOCKTHERAPY || this.props.agencyName.toUpperCase() === IAT)
        {
          if(slotInfo.noteTypeId === 101){          
            history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else {
            history.push(`/my-session-notes-data-collection/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
        }
        else if(this.props.agencyName.toUpperCase().startsWith(EBS))
        {           
          if(slotInfo.notetypeId === 1){
            history.push(`/my-session-notes-data-collection/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } 
          else if(slotInfo.notetypeId === 2){
            history.push(`/my-session-notes-early-intervention/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } 
          else if(slotInfo.notetypeId === 3){
            history.push(`/my-session-notes-delaware-ei-ebs/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } 
          else if(slotInfo.notetypeId === 4){
            history.push(`/my-session-notes-ifsp-developmenttime-ebs/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
          else if(slotInfo.notetypeId === 5){
            history.push(`/my-session-notes-illinois-evaluation-ebs/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
          else if(slotInfo.notetypeId === 6){
            history.push(`/my-session-notes-illinois-ebs/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 101){          
            history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }          
        }
        else if(this.props.agencyName.toUpperCase() === CBG)
        { 
            if(slotInfo.noteTypeId === 1){
              history.push(`/my-session-cbg/${slotInfo.id}/${slotInfo.patientEncounterId}`);
            }
            else if(slotInfo.noteTypeId === 2){
              history.push(`/my-progress-note-one/${slotInfo.id}/${slotInfo.patientEncounterId}`);
            } else if(slotInfo.noteTypeId === 101){          
              history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
            } else if(slotInfo.noteTypeId === 102){          
              history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
            }
        }
        else if(this.props.agencyName.toUpperCase() === AIP)
        {
          if(slotInfo.noteTypeId === 101){          
            history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else {
            history.push(`/my-session-aip/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
        }
        else if(this.props.agencyName.toUpperCase() === NE_ABA)
        {
          if(slotInfo.noteTypeId === 101){          
            history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else {
            history.push(`/my-session-ne-aba/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
        }
        else if(this.props.agencyName.toUpperCase() === POSITIVEBEHAVIORSTEPS)
        {
          if(slotInfo.noteTypeId === 101){          
            history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else {
            history.push(`/my-session-pbs/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
        }        
        else if(this.props.agencyName.toUpperCase() === BESTABA)
        {
          if(slotInfo.noteTypeId === 1){
            history.push(`/my-session-bt-bestaba/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
          else if(slotInfo.noteTypeId === 2){
            history.push(`/my-session-bcba-bestaba/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 101){          
            history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
        }
        else if(this.props.agencyName.toUpperCase() === SWANCONSULTINGINC)
        {
          if(slotInfo.noteTypeId === 1){
            history.push(`/${patientMySoap}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
          else if(slotInfo.noteTypeId === 2){
            history.push(`/my-session-psychological-swan/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 101){          
            history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }else if(slotInfo.noteTypeId > 102){          
            history.push(`/${patientCustomSessionSoapNote}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
        }
        else if(this.props.agencyName.toUpperCase() === CAS)
        {
          if(slotInfo.noteTypeId === 1){
            history.push(`/${patientMySoap}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
          else if(slotInfo.noteTypeId === 2){
            history.push(`/my-progress-note-one/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 101){          
            history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }else if(slotInfo.noteTypeId > 102){          
            history.push(`/${patientCustomSessionSoapNote}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
        }
        else if(this.props.agencyName.toUpperCase() === VICTORIOUSLEARNING)
        {
          if(slotInfo.noteTypeId === 1){
            history.push(`/${patientMySoap}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
          else if(slotInfo.noteTypeId === 2){
            history.push(`/my-progress-note-one/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 101){          
            history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }else if(slotInfo.noteTypeId === 102){          
            history.push(`/${patientCustomSessionSoapNote}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
        }
        else if(this.props.agencyName.toUpperCase() === ABAORLANDO)
        {
          if(slotInfo.noteTypeId === 1){
            history.push(`/${patientMySoap}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 2){
            history.push(`/my-session-rbt-abaor/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 3){
            history.push(`/my-session-bcba-abaor/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 101){          
            history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }else if(slotInfo.noteTypeId === 102){          
            history.push(`/${patientCustomSessionSoapNote}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
        }
        else if(this.props.agencyName.toUpperCase() === SOAR)
        {
          if(slotInfo.noteTypeId === 1){
            history.push(`/${patientMySoap}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 2){
            history.push(`/my-session-assessment-soar/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 3){
            history.push(`/my-session-directtherapy-soar/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 4){
            history.push(`/my-session-bcbasupervision-soar/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 5){
            history.push(`/my-session-familytreatment-soar/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 6){
            history.push(`/my-session-diagnosticevaluation-soar/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 101){          
            history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId > 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } 
        }
        else if(this.props.agencyName.toUpperCase() === HYPERIONCENTER)
        {
          if(slotInfo.noteTypeId === 1){
            history.push(`/${patientMySoap}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 2){
            history.push(`/my-session-hyperion/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 101){          
            history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }else if(slotInfo.noteTypeId > 102){          
            history.push(`/${patientCustomSessionSoapNote}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
        }
        else if(this.props.agencyName.toUpperCase() === HELPINGHANDS)
        {
          if(slotInfo.noteTypeId === 1){
            history.push(`/${patientMySoap}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 2){
            history.push(`/my-session-supervision-helpinghands/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 101){          
            history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }else if(slotInfo.noteTypeId > 102){          
            history.push(`/${patientCustomSessionSoapNote}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
        }
        else if(this.props.agencyName.toUpperCase() === FUTURES)
        {
          if(slotInfo.noteTypeId === 1){
            history.push(`/${patientMySoap}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 2){
            history.push(`/my-session-psycheval-futures/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 3){
            history.push(`/my-session-slpeval-futures/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 101){          
            history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }else if(slotInfo.noteTypeId > 102){          
            history.push(`/${patientCustomSessionSoapNote}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }
        }
        else if(this.props.agencyName.toUpperCase() === TFABA)
        {
          if(slotInfo.noteTypeId === 1){
            history.push(`/${patientMySoap}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 2){
            history.push(`/my-session-rbt-tfaba/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 3){
            history.push(`/my-session-bcba-tfaba/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 101){          
            history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          } else if(slotInfo.noteTypeId === 102){          
            history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }  else if(slotInfo.noteTypeId > 102){          
            history.push(`/${patientCustomSessionSoapNote}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
          }  
        }
        else
        {
            if(slotInfo.noteTypeId === 1){
              history.push(`/${patientMySoap}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
            } else if(slotInfo.noteTypeId === 101){          
              history.push(`/my-session-bt-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
            } else if(slotInfo.noteTypeId === 102){          
              history.push(`/my-session-bcba-default/${slotInfo.id}/${slotInfo.patientEncounterId}`);
            } else if(slotInfo.noteTypeId > 102){          
              history.push(`/${patientCustomSessionSoapNote}/${slotInfo.id}/${slotInfo.patientEncounterId}`);
            }           
        }
      }
    } else if (slotInfo.action === 'cancel') {
      Alert.closeAll();
      this.setState({ showCancelAppointmentDialog: true, appointmentId: slotInfo.id });
    }
  }

  closeCancelAppointmentDialog() {
    this.setState({ showCancelAppointmentDialog: false, appointmentId: null });
  }

  eventStyleGetter(event, date, end, isSelected) { // , start, end, isSelected
    // let backgroundColor = event.appointmentTypeColor;
    let style = {
      backgroundColor: event.appointmentBackgroundColor,
      color: event.appointmentFontColor,
    };
    return {
      style: style,
    };
  }

  onDateChange(input, value) {
    input.onChange(moment(value).format('YYYY-MM-DD'));
    this.setState({ [input.name]: value });
    let month = moment(value).get('month');
    this.renderMonthNavigation(month, value);
  }

  onNavigateMonth(date) {
    let month = moment(date).get('month');
    this.setState({ schedulerDate: date });
    this.renderMonthNavigation(month, date);
  }

  renderMonthNavigation(month, date) {
    if (month !== this.filter.currentMonth) {
      this.filter.currentMonth = month;
      this.setFilteredDateObject(date);
      if (this.state.patient_id) {
        this.get_patient_appointments();
      }
    }
  }

  handleStaffView(view) {
    // console.log('leftView----', view);
    // this.setState({ schedulerDate: date });
    this.filter.currentView = view;
    if (this.filter.currentView === 'month') {
      this.setState((prevState, props) => {
        let appointments = prevState.appointments.map((Obj) => {
          Obj.title = Obj.appointmentTime + '\n' + Obj.title;
          return Obj;
        });
        return { appointments: appointments };
      });
    } else {
      this.setState((prevState, props) => {
        let appointments = prevState.appointments.map((Obj) => {
          Obj.title = Obj.title.replace(Obj.appointmentTime, '');
          return Obj;
        });
        return { appointments: appointments };
      });
    }
  }

  openDatePicker() {
    this.refs.dp.openDialog();
  }

  render() {
    let formats = {
      dayFormat: (date, culture, localizer) =>
        localizer.format(date, 'ddd MM/DD', culture),
    };
    let scheduler_view = this.state.patient_views;
    let today = moment();

    let am8 = today.set('hour', this.state.startHour).set('minutes', this.state.startMinutes).toDate();
    let pm8 = today.set('hour', this.state.endHour).set('minutes', this.state.endMinutes).toDate();
    return (
      <div>

        {
          this.state.showCancelAppointmentDialog ?
            <CancelAppointmentDialog
              patientAppointmentId={this.state.appointmentId}
              showCancelAppointmentDialog={this.state.showCancelAppointmentDialog}
              closeCancelAppointmentDialog={this.closeCancelAppointmentDialog}
              isRequestFromPatientPortal={true} />
            : null
        }


        <h2 className="page_title">My Appointments</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="calandericon">
              <div className="customdateschedule">
                <RaisedButton className="dateicon" onTouchTap={this.openDatePicker.bind(this)}>
                  <i className="material-icons">date_range</i>
                </RaisedButton>
                <DatePicker
                  ref="dp"
                  name="datefield"
                  id="datefieldicon"
                  container="inline"
                  locale="en-US"
                  fullWidth={true}
                  minDate={new Date(1900, 1, 1)}
                  value={this.state.schedulerDate ? new Date(this.state.schedulerDate) : {}}
                  autoOk={true}
                  style={{ display: 'inline-block', width: '0px', visibility: 'hidden' }}
                  onChange={(event, value) => this.setState({ schedulerDate: value }) } />
              </div>
            </div>
            <BigCalendar
              selectable
              min={am8}
              max={pm8}
              events={this.state.appointments}
              defaultView={this.filter.currentView}
              scrollToTime={new Date(1970, 1, 1, 6)}
              defaultDate={new Date()}
              date={this.state.schedulerDate}
              formats={formats}
              views={scheduler_view}
              onSelectEvent={(event) => this.openDialog(event)}
              onView={(e) => this.handleStaffView(e)}
              eventPropGetter={(event, date, end, isSelected) => this.eventStyleGetter(event, date, end, isSelected)}
              onSelectSlot={(slotInfo) =>
                this.openDialog(slotInfo)
              }
              onNavigate={this.onNavigateMonth}
              usersAvailability = {null}
            />

          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let patientId, locationID;
  if (state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.roleName === 'Client') {
    patientId = state.login.loginUserInfo.id;
    locationID = state.login.loginUserInfo.locationID;
  } else {
    patientId = state.patient.patientId;
    locationID = state.login.currentLocationId;
  }
  return {
    patientId: patientId,
    appointments: state.patientPortal.patientAppointmentList,
    currentLocationId: locationID,
    officeHours: state.patientPortal.office_hours,
    cancelledAppointment: state.scheduling.cancelledAppointment,
    app_config: state.appConfig.appConfigList ? state.appConfig.appConfigList.data : null,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
};

export default connect(mapStateToProps, {
  getPatientAppointmentList,
  getOfficeHours,
  getAppConfigList,
})(Scheduling);



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/details/components/patient_scheduler_Client.js